import TripsDemo from './TripsDemo';

export default TripsDemo;
